import React from 'react';
import { CheckCircle } from 'lucide-react';
import PRICING from '../config/pricing';

const FreeTrialBanner = ({
  freeTrialStatus,
  photos,
  selectedPhotos,
  scrollToProcessingOptions
}) => {
  // Only show if user has free trial and photos are loaded
  if (!freeTrialStatus || !freeTrialStatus.isEligible || photos.length === 0) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-green-500 to-blue-500 rounded-xl p-6 mb-6 text-white">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <h3 className="text-xl font-bold mb-2">
            {freeTrialStatus.remainingPhotos > 0 ? (
              <>You have {freeTrialStatus.remainingPhotos} free photos left — Select Some Now!</>
            ) : (
              "Free Trial Used — Continue with Premium"
            )}
          </h3>
          
          {/* Progress Bar */}
          <div className="mb-3">
            <div className="flex justify-between text-sm mb-2">
              <span>Free Trial Progress</span>
              <span>{freeTrialStatus.photosUsed || 0}/{freeTrialStatus.maxPhotos}</span>
            </div>
            <div className="w-full bg-white bg-opacity-20 rounded-full h-2">
              <div 
                className="bg-white h-2 rounded-full transition-all duration-300"
                style={{ width: `${((freeTrialStatus.photosUsed || 0) / freeTrialStatus.maxPhotos) * 100}%` }}
              ></div>
            </div>
          </div>
          
          <p className="text-white text-opacity-90 text-sm">
            {freeTrialStatus.remainingPhotos > 0 ? (
              "Try our AI-powered metadata generation completely free!"
            ) : (
              `Continue enhancing your photos for just ${PRICING.getDisplayRate()} per photo`
            )}
          </p>
        </div>
        
        {selectedPhotos.size > 0 && (
          <div className="text-center lg:text-right">
            <button
              onClick={scrollToProcessingOptions}
              className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-bold transition-all duration-200 hover:scale-105 cursor-pointer ${
                freeTrialStatus.remainingPhotos >= selectedPhotos.size 
                  ? 'bg-white bg-opacity-20 text-white hover:bg-opacity-30'
                  : 'bg-orange-100 text-orange-800 hover:bg-orange-200'
              }`}
            >
              {freeTrialStatus.remainingPhotos >= selectedPhotos.size ? (
                <>
                  <CheckCircle className="w-4 h-4 mr-2" />
                  {selectedPhotos.size} photos - FREE
                </>
              ) : (
                <>
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" />
                  </svg>
                  {PRICING.formatPrice(PRICING.calculateAmountWithFreeTrial(selectedPhotos.size, freeTrialStatus.remainingPhotos))} for {selectedPhotos.size - freeTrialStatus.remainingPhotos} photos
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FreeTrialBanner;
